import React from 'react';
import { useTheme } from '@emotion/react';

export default ({ colour }: { colour?: string }): JSX.Element => {
    const theme = useTheme();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 35 36" fill="none">
            <path
                stroke={colour || theme.colours.darkGray}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M17.5 21.355a6.16 6.16 0 0 0 4.422-1.887 6.545 6.545 0 0 0 1.832-4.557c0-1.71-.659-3.348-1.832-4.557a6.163 6.163 0 0 0-4.423-1.888c-1.659 0-3.25.68-4.423 1.888a6.545 6.545 0 0 0-1.832 4.557c0 1.71.66 3.348 1.832 4.557a6.163 6.163 0 0 0 4.423 1.887Zm0 0c2.607 0 5.125.982 7.08 2.76a11.135 11.135 0 0 1 3.538 6.897c-2.97 2.583-6.733 3.996-10.619 3.988-3.886.008-7.65-1.405-10.619-3.988m10.62-9.657c-2.609 0-5.127.982-7.082 2.76a11.134 11.134 0 0 0-3.538 6.897m0 0a17.068 17.068 0 0 1-5.321-8.625 17.49 17.49 0 0 1 .44-10.21 16.94 16.94 0 0 1 6.04-8.105A16.17 16.17 0 0 1 17.5 1a16.16 16.16 0 0 1 9.46 3.072c2.773 2 4.883 4.829 6.042 8.105a17.49 17.49 0 0 1 .44 10.21 17.07 17.07 0 0 1-5.322 8.625"
            />
        </svg>
    );
};
